// Client-side auth token storage (JWT issued by the backend /api/auth/login).
const TOKEN_KEY = "oim_token";
const USER_KEY = "oim_user";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const getUser = () => localStorage.getItem(USER_KEY);
export const isAuthed = () => !!getToken();

export function setAuth(token, username) {
  localStorage.setItem(TOKEN_KEY, token);
  if (username) localStorage.setItem(USER_KEY, username);
}

export function clearAuth() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}
